var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaitWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0065 0C11.0612 0 10.2918 0.769319 10.2918 1.71471C10.2918 2.66344 11.0612 3.42941 12.0065 3.42941C12.9553 3.42941 13.7213 2.66327 13.7213 1.71471C13.7213 0.769319 12.9551 0 12.0065 0ZM0 12.0065C0 12.9553 0.769319 13.7213 1.71471 13.7213C2.66344 13.7213 3.42941 12.9551 3.42941 12.0065C3.42941 11.0612 2.66327 10.2918 1.71471 10.2918C0.769319 10.2918 0 11.0612 0 12.0065ZM20.4987 3.51749C21.1671 4.18582 21.1671 5.27139 20.4987 5.9429C19.8272 6.61123 18.7416 6.61123 18.0701 5.9429C17.4018 5.27139 17.4018 4.18578 18.0701 3.51749C18.7416 2.84598 19.8272 2.84598 20.4987 3.51749ZM5.94296 18.0703C6.61129 18.7418 6.61129 19.8274 5.94296 20.4989C5.27145 21.1672 4.18584 21.1672 3.51755 20.4989C2.84604 19.8274 2.84604 18.7418 3.51755 18.0703C4.18588 17.4019 5.27145 17.4019 5.94296 18.0703ZM3.51755 3.51749C2.84604 4.18582 2.84604 5.27139 3.51755 5.9429C4.18588 6.61123 5.27145 6.61123 5.94296 5.9429C6.61129 5.27139 6.61129 4.18578 5.94296 3.51749C5.27145 2.84598 4.18584 2.84598 3.51755 3.51749ZM12.0066 20.5835C11.0612 20.5835 10.2919 21.3528 10.2919 22.2982C10.2919 23.2469 11.0612 24.0129 12.0066 24.0129C12.9553 24.0129 13.7213 23.2468 13.7213 22.2982C13.7213 21.3528 12.9552 20.5835 12.0066 20.5835Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitWhite);
export default __webpack_public_path__ + "static/media/wait-white.cdf6d7fb9ec3ce5885d1801747392db3.svg";
export { ForwardRef as ReactComponent };